function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/* eslint-disable no-nested-ternary */
import { defineComponent, ref, computed, onMounted, watch, onBeforeUnmount, h } from '@vue/composition-api';
import Config from '../config';
import { withInstall, useExpose } from '../util/index';
import "../style/components/swiper.css";
var Swiper = defineComponent({
  name: 'm-swiper',
  props: {
    list: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    index: {
      type: Number,
      "default": 0
    },
    // 是否垂直滚动
    vertical: {
      type: Boolean,
      "default": false
    },
    // 是否循环滚动
    loop: {
      type: Boolean,
      "default": true
    },
    // 动画过渡时间
    duration: {
      type: Number,
      "default": 500
    },
    // 自动播放
    autoplay: {
      type: Boolean,
      "default": true
    },
    // 自动播放间隔
    interval: {
      type: Number,
      "default": 2000
    },
    // 是否跟随手指
    follow: {
      type: Boolean,
      "default": true
    },
    isRtl: {
      type: Boolean,
      "default": false
    },
    // 是否显示指示器
    showIndicator: {
      type: Boolean,
      "default": true
    },
    // 指示器颜色
    indicatorColor: {
      type: String,
      "default": '#fff'
    },
    // item尺寸与swiper容器尺寸的比例, 大于0小于等于1的小数
    scale: {
      type: Number,
      "default": 1
    },
    // scale小于1时的对齐方式
    align: {
      type: String,
      "default": 'center'
    },
    // 滑动阈值
    minDistance: {
      type: Number,
      "default": 5
    },
    // 角度阈值
    touchAngle: {
      type: Number,
      "default": 45
    },
    // 判定距离，超出则忽略本次交互
    maxDistance: {
      type: Number,
      "default": 1000
    }
  },
  emits: ['change'],
  slots: ['item', 'indicator'],
  setup: function setup(props, context) {
    var touches = {
      startX: 0,
      startY: 0,
      isScrolling: false,
      autoPlay: false,
      overDistance: false
    };
    var transformTimer;
    var playTimer;
    var autoPlay = ref(props.autoplay); // 横向滚动并且为rtl时整体要做反向操作

    var reverseSign = computed(function () {
      return (props.isRtl || Config.getDirection() === 'rtl') && !props.vertical ? -1 : 1;
    });
    var distance = ref(0);
    var isInTouch = ref(true);
    var items = computed(function () {
      var len = props.list.length;

      if (len <= 1 || !props.loop) {
        return props.list;
      }

      return [props.list[len - 1]].concat(_toConsumableArray(props.list), [props.list[0]]);
    });
    var targetIndex = ref(0);
    var originIndexStack = computed(function () {
      var listLen = items.value.length;
      var stack = [];

      for (var i = 0; i < listLen; i++) {
        if (props.loop && listLen > 1) {
          var maxIndex = listLen - 1;
          stack[i] = i === 0 ? maxIndex - 2 : i === maxIndex ? 0 : i - 1;
        } else {
          stack[i] = i;
        }
      }

      return stack;
    }); // 计算item尺寸

    var itemSize = ref(0);
    onMounted(function () {
      var $swiper = context.refs.$swiper;

      if (!$swiper) {
        return;
      }

      itemSize.value = props.vertical ? $swiper.clientHeight : $swiper.clientWidth;
    }); // 计算每个Item的样式，区分横竖向模式

    var itemStyle = computed(function () {
      if (!itemSize.value) {
        return null;
      }

      return props.vertical ? {
        height: "".concat(itemSize.value * props.scale, "px")
      } : {
        width: "".concat(itemSize.value * props.scale, "px")
      };
    }); // 当前偏移量

    var wrapperOffset = computed(function () {
      var tailWith = props.align === 'left' ? 0 : props.align === 'right' ? (1 - props.scale) * itemSize.value : (1 - props.scale) / 2 * itemSize.value;
      return distance.value - targetIndex.value * (itemSize.value * props.scale) + tailWith;
    }); // 计算swiper样式

    var swiperStyle = computed(function () {
      var styleObj = {};

      if (!props.vertical) {
        styleObj.direction = props.isRtl || Config.getDirection() === 'rtl' ? 'rtl' : 'ltr';
      }

      return styleObj;
    }); // 计算container样式

    var containerStyle = computed(function () {
      var styleObj = {};

      if (props.vertical) {
        styleObj.height = "".concat(itemSize.value * props.scale, "px");
      }

      return styleObj;
    }); // 计算滑动区域样式

    var sliderStyle = computed(function () {
      if (items.value.length <= 1) {
        var align = props.align;
        var justifyContent = reverseSign.value > 0 || align === 'center' ? align : align === 'left' ? 'right' : 'left';
        return {
          minWidth: '100%',
          justifyContent: justifyContent
        };
      }

      return {
        transform: props.vertical ? "translate3D(0, ".concat(wrapperOffset.value, "px, 0)") : "translate3D(".concat(wrapperOffset.value * reverseSign.value, "px, 0, 0)"),
        transition: isInTouch.value ? '' : "all ".concat(props.duration, "ms ease")
      };
    }); // 计算是否满足滑动条件

    function isValidTouch(e) {
      // 已经在滑动中
      if (touches.isScrolling) return true; // 条目不足

      var maxIndex = items.value.length - 1;
      if (maxIndex <= 0 || touches.overDistance) return false; // 当前触摸移动距离小于设定的最小值时不满足滑动条件

      var diffX = Math.abs(e.changedTouches[0].clientX - touches.startX);
      var diffY = Math.abs(e.changedTouches[0].clientY - touches.startY);
      var absDistance = props.vertical ? diffY : diffX;
      if (absDistance < props.minDistance) return false;

      if (absDistance > props.maxDistance) {
        touches.overDistance = true;
        return false;
      } // 在滑动过程中检测滑动角度是否满足角度阈值


      var touchAngle = Math.atan2(diffY, diffX) * 180 / Math.PI;
      touches.isScrolling = !props.vertical && touchAngle <= props.touchAngle || props.vertical && 90 - touchAngle <= props.touchAngle;
      return touches.isScrolling;
    } // 是否为边界item


    var isLeftSideItem = function isLeftSideItem(index) {
      return index === 0;
    };

    var isRightSideItem = function isRightSideItem(index) {
      return index === items.value.length - 1;
    };

    var isSideItem = function isSideItem(index) {
      return isLeftSideItem(index) || isRightSideItem(index);
    }; // 滚动items


    function moveItems(index) {
      targetIndex.value = index;
      transformTimer = setTimeout(function () {
        if (props.loop && isSideItem(index)) {
          isInTouch.value = true;
          targetIndex.value = index === 0 ? items.value.length - 2 : 1;
        }

        context.emit('change', originIndexStack.value[index]);
      }, props.duration);
    } // 设置自动滚动


    function _play() {
      if (items.value.length <= 1 || !props.loop && reverseSign.value < 0 && isLeftSideItem(targetIndex.value) || !props.loop && reverseSign.value > 0 && isRightSideItem(targetIndex.value)) {
        return;
      }

      autoPlay.value = true;
      playTimer = setTimeout(function () {
        isInTouch.value = false;
        moveItems(targetIndex.value + 1);

        _play();
      }, props.interval + props.duration);
    }

    function pause() {
      playTimer && clearTimeout(playTimer);
      transformTimer && clearTimeout(transformTimer);
      autoPlay.value = false;
    }

    function onTouchmove(e) {
      if (!isValidTouch(e)) return;

      if (typeof e.cancelable !== 'boolean' || e.cancelable) {
        e.preventDefault();
      }

      if (!props.follow) return; // 满足滑动条件时内容跟随手指

      var scrollDistance = props.vertical ? e.changedTouches[0].clientY - touches.startY : e.changedTouches[0].clientX - touches.startX;
      distance.value = scrollDistance * reverseSign.value;
    }

    function onTouchend(e) {
      distance.value = 0; // 处理自动滚动

      if (touches.autoPlay) {
        _play();
      }

      if (!isValidTouch(e)) {
        touches.isScrolling = false;
        touches.overDistance = false;
        return;
      }

      touches.isScrolling = false;
      touches.overDistance = false;
      var diffIndex = 0;
      var touch = e.changedTouches[0];

      if (props.vertical && touch.clientY !== touches.startY) {
        diffIndex = touch.clientY > touches.startY ? 1 : -1;
      } else if (!props.vertical && touch.clientX !== touches.startX) {
        diffIndex = touch.clientX > touches.startX ? 1 : -1;
      }

      var maxIndex = items.value.length - 1;
      var sign = diffIndex >= 0 ? 1 : -1;
      var computedIndex = targetIndex.value - Math.ceil(Math.abs(diffIndex)) * sign * reverseSign.value;
      isInTouch.value = false;
      moveItems(computedIndex < 0 ? 0 : computedIndex > maxIndex ? maxIndex : computedIndex);
    }

    function onTouchstart(e) {
      isInTouch.value = true;
      touches.autoPlay = autoPlay.value;
      pause(); // 处理快速滚动边界item换位中断

      if (props.loop && isSideItem(targetIndex.value)) {
        targetIndex.value = targetIndex.value === 0 ? items.value.length - 2 : 1;
      }

      touches.startX = e.changedTouches[0].clientX;
      touches.startY = e.changedTouches[0].clientY;
    } // 响应props.index变化


    function slideTo(index) {
      var disableAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (index < 0 || index > props.list.length - 1 || index === originIndexStack.value[targetIndex.value]) {
        return;
      }

      isInTouch.value = disableAnimate;
      var listLen = props.list.length;
      moveItems(!props.loop ? index : index === 0 ? 1 : index === listLen - 1 ? listLen : index + 1);

      if (autoPlay.value) {
        pause();

        _play();
      }
    }

    onMounted(function () {
      context.emit('change', props.index);
      slideTo(props.index, true);
    });
    watch(function () {
      return props.index;
    }, function (newVal) {
      slideTo(newVal);
    });
    watch(function () {
      return props.list;
    }, function (newVal) {
      slideTo(originIndexStack.value[Math.max(Math.min(targetIndex.value, originIndexStack.value.length - 1), 0)], true);
    });
    watch(function () {
      return props.autoplay;
    }, function (newVal) {
      if (newVal !== autoPlay.value) {
        newVal ? _play() : pause();
      }
    }); // 清除定时器

    onBeforeUnmount(function () {
      pause();
    }); // 暴露方法

    useExpose({
      slideTo: slideTo,
      pause: pause,
      play: function play() {
        pause();

        _play();
      }
    });
    return function () {
      return h("div", {
        "ref": '$swiper',
        "class": {
          'm-swiper': true,
          'm-swiper__horizontal': !props.vertical
        },
        "style": swiperStyle.value
      }, [h("div", {
        "on": {
          "touchstart": onTouchstart,
          "touchmove": onTouchmove,
          "touchend": onTouchend,
          "touchCancel": onTouchend
        },
        "class": 'm-swiper__container',
        "style": containerStyle.value
      }, [h("div", {
        "class": {
          'm-swiper__wrapper': true
        },
        "style": sliderStyle.value
      }, [items.value.map(function (item, idx) {
        var _context$slots$item, _context$slots;

        return h("div", {
          "key": idx,
          "class": 'm-swiper__item',
          "style": itemStyle.value
        }, [(_context$slots$item = (_context$slots = context.slots).item) === null || _context$slots$item === void 0 ? void 0 : _context$slots$item.call(_context$slots, {
          item: item,
          target: originIndexStack.value[targetIndex.value],
          index: originIndexStack.value[idx],
          active: idx === targetIndex.value,
          slideTo: slideTo
        })]);
      })])]), props.showIndicator && props.list.length > 1 && (context.slots.indicator ? context.slots.indicator({
        length: props.list.length,
        target: originIndexStack.value[targetIndex.value],
        slideTo: slideTo
      }) : h("div", {
        "class": 'm-swiper__indicator'
      }, [props.list.map(function (item, idx) {
        var active = originIndexStack.value[targetIndex.value] === idx;
        return h("div", {
          "key": idx,
          "class": {
            active: active,
            'm-swiper__indicator-item': true
          },
          "style": {
            backgroundColor: props.indicatorColor
          },
          "on": {
            "click": function click() {
              slideTo(idx);
            }
          }
        }, [active]);
      })]))]);
    };
  }
});
withInstall(Swiper);
export default Swiper;